import { Schema, SchemaSettings } from '@orbit/data'
import { KC } from '@/http/utils'
import { DataPoint, InhalerUsage } from '@/jsonapi/CommonTypes'

enum ModelTypes {
  PatientWithDetailedReports = 'patient-with-detailed-report',
}

enum ModelTypeNames {
  PatientWithDetailedReports = 'patientWithDetailedReport',
}

export type DetailedSleepReport = {
  avgMajorInterruptionPerNight?: number
  avgNumOfAwakeningsPerNight?: number
  numOfAwakenings?: DataPoint[]
  sleepEfficiencies?: DataPoint[]
  totalSleepTimes?: DataPoint[]
  majorInterruptions?: DataPoint[]
}

export type DetailedActivitiesReport = {
  avgStepsCountPerDay?: number
  avgSedentaryTimePerDay?: number
  sedentaryDurationInMinutePerDay?: DataPoint[]
  casualWalkSteps?: DataPoint[]
  walkDurations?: DataPoint[]
  casualWalkDistances?: DataPoint[]
}

export type DetailedInhalersReport = {
  nonAdherentDays?: number
  hasSignOfShortnessOfBreath?: boolean
  inhalerUsages?: InhalerUsage[]
  inhalerDurations?: InhalerUsage[]
  nightInhalerUsages?: InhalerUsage[]
  overUsages?: DataPoint[]
  maintenanceAdherenceRatePerc?: number
  uncontrolledDays?: number
  controlledDays?: number
}

export type PatientWithDetailedReportsAttributes = {
  patientId: string
  sleepReport?: DetailedSleepReport
  activityReport?: DetailedActivitiesReport
  inhalersReport?: DetailedInhalersReport
  starttimestamp?: number
  endtimestamp?: number
  resultStartTimestamp?: number
  resultEndTimestamp?: number
  firstName?: string
  lastName?: string
  timezone?: string
}

export interface PatientWithDetailedReportsSchema {
  id: string
  attributes: PatientWithDetailedReportsAttributes
}

export interface GetPatientWithDetailedReportsByIdDto {
  patientId: string
  startTimestamp: number
  endTimestamp: number
}

const schemaDefinition: SchemaSettings = {
  models: {
    [ModelTypeNames.PatientWithDetailedReports]: {
      attributes: {
        patientId: { type: 'string' },
        sleepReport: { type: 'object' },
        activityReport: { type: 'object' },
        inhalersReport: { type: 'object' },
        starttimestamp: { type: 'number' },
        endtimestamp: { type: 'number' },
        resultStartTimestamp: { type: 'number' },
        resultEndTimestamp: { type: 'number' },
        firstName: { type: 'string' },
        lastName: { type: 'string' },
        timezone: { type: 'string' },
      },
    },
  },
}

export async function getPatientWithDetailedReportsById(params: GetPatientWithDetailedReportsByIdDto) {
  const schema = new Schema(schemaDefinition)
  const remote = await KC.getJsonApiRemoteResource(schema)
  return remote
    .query(q => {
      console.log('Before calling find record for patient with detailed reports', 'id:', params)
      return q
        .findRecords(ModelTypes.PatientWithDetailedReports)
        .filter(
          { attribute: 'id', value: params.patientId },
          { attribute: 'starttimestamp', value: params.startTimestamp },
          { attribute: 'endtimestamp', value: params.endTimestamp }
        )
    })
    .catch(() => {
      console.log('fetch failed in get patient with detailed reports ')
    })
}
